"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Modal = require("@insided/shared/uikit/Modal");

var _index = _interopRequireDefault(require("../button-control/index"));

var _BadgeSelector = _interopRequireDefault(require("../badges/BadgeSelector"));

var _axios = _interopRequireDefault(require("axios"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AwardBadgeModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AwardBadgeModal, _Component);

  var _super = _createSuper(AwardBadgeModal);

  function AwardBadgeModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AwardBadgeModal);
    _this = _super.call(this, props);
    _this.state = {
      badgesList: null,
      selectedBadge: null,
      isModalOpen: true
    };
    _this.awardBadge = _this.awardBadge.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBadgeSelected = _this.onBadgeSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.trackBadgeAwardedEvent = _this.trackBadgeAwardedEvent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AwardBadgeModal, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get('/settings/badge/getBadgesList');

              case 2:
                response = _context.sent;
                this.setState({
                  badgesList: response.data
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "awardBadge",
    value: function () {
      var _awardBadge = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this2 = this;

        var selectedBadge, userName;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectedBadge = this.state.selectedBadge;
                userName = this.props.userName;

                if (selectedBadge) {
                  _context2.next = 5;
                  break;
                }

                this.setState({
                  error: 'Please select a badge'
                });
                return _context2.abrupt("return");

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return _axios.default.post('/settings/badge/award', {
                  badgeId: selectedBadge,
                  userNames: [userName]
                }).then(function () {
                  _this2.trackBadgeAwardedEvent(selectedBadge);

                  _this2.closeModal();

                  window.location.reload();
                });

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 10]]);
      }));

      function awardBadge() {
        return _awardBadge.apply(this, arguments);
      }

      return awardBadge;
    }()
  }, {
    key: "trackBadgeAwardedEvent",
    value: function trackBadgeAwardedEvent(selectedBadge) {
      var badgesList = this.state.badgesList;
      var _this$props = this.props,
          awarderId = _this$props.awarderId,
          awarderUsername = _this$props.awarderUsername,
          awarderRole = _this$props.awarderRole,
          userId = _this$props.userId,
          userName = _this$props.userName,
          userRole = _this$props.userRole;
      if (!badgesList) return;
      var awardedBadge = badgesList.find(function (badge) {
        return badge.id.toString() === selectedBadge;
      });
      if (!awardedBadge) return;

      _publish.default.trackEvent('userevent', {
        type: 'Badge Awarded',
        badgeId: awardedBadge.id,
        badgeName: awardedBadge.title,
        badgeDescription: awardedBadge.description,
        awarderId: awarderId,
        awarderUsername: awarderUsername,
        awarderRole: awarderRole,
        awardedId: userId,
        awardedUsername: userName,
        awardedRole: userRole
      });
    }
  }, {
    key: "onBadgeSelected",
    value: function onBadgeSelected(badgeId) {
      this.setState({
        selectedBadge: badgeId,
        error: undefined
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        isModalOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var state = this.state;
      if (!state.badgesList) return null;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: state.isModalOpen
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Award badge",
        onClose: function onClose() {
          return _this3.closeModal();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_BadgeSelector.default, {
        badges: state.badgesList,
        selected: state.badgesList.find(function (badge) {
          return badge.id.toString() === state.selectedBadge;
        }),
        onChange: this.onBadgeSelected,
        error: state.error
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_index.default, {
        title: "Award",
        variant: "primary",
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", _this3.awardBadge());

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))
      }), (0, _preact.h)(_index.default, {
        title: "Cancel",
        onClick: function onClick() {
          return _this3.closeModal();
        }
      })));
    }
  }]);
  return AwardBadgeModal;
}(_preact.Component);

var _default = AwardBadgeModal;
exports.default = _default;